import { BaseComponent } from "utils/base-component"

export class FeatureNewsPosts extends BaseComponent {
  static cssClass = "feature-news-posts"

  init() {
    this.linkNewsPosts()
  }

  private linkNewsPosts() {
    const articles = this.root.querySelectorAll<HTMLElement>(
      `.${this.cssClass}__feature[data-link], .${this.cssClass}__post[data-link]`,
    )

    articles.forEach((article) => {
      article.addEventListener("click", (event) => {
        // Don't navigate if clicking on a link inside the article
        const target = event.target as HTMLElement
        if (target.closest("a")) {
          return
        }

        const link = article.getAttribute("data-link")
        if (link) {
          window.open(link, "_blank", "noopener")
        }
      })
    })
  }
}
